var $c7c7bc6cc4226b9e$exports = {};
$c7c7bc6cc4226b9e$exports = {
    "endTime": `\u{7D50}\u{675F}\u{6642}\u{9593}`,
    "startTime": `\u{958B}\u{59CB}\u{6642}\u{9593}`,
    "time": `\u{6642}\u{9593}`
};


export {$c7c7bc6cc4226b9e$exports as default};
//# sourceMappingURL=zh-TW.module.js.map
